import type {Part, PartAction} from 'schemaDefinition/types';

export const makePartPath = (
  scopePath: string | undefined,
  part: Pick<Part | PartAction, 'name' | 'type'>,
): string => {
  return scopePath
    ? scopePath +
        (part.type !== 'expand' && part.type !== 'action'
          ? `.${part.name?.toString()}`
          : '')
    : (part.name?.toString() ?? '');
};
